// extracted by mini-css-extract-plugin
export default {"header":"Table_header__sTyrR","link":"Table_link__yZJ-2","active":"Table_active__4y4z-","inactive":"Table_inactive__s46qs"};